<h2 class={$$props.class}>
  <slot />
</h2>

<style lang="scss">
  h2 {
    font-family: "burgess-regular-pro";
    font-weight: normal;
    font-size: 1.5625rem;
    line-height: 1.75rem;
    color: #0A2F54;
    text-align: center;
    margin: 0;
  }
</style>
